import BusinessList from './BusinessList';
import BusinessShow from './BusinessShow';

export default {
  list: BusinessList,
  show: BusinessShow,
};
